// 物料申领
import {contractApi} from "@/axios";
//获取申领信息
export function getRequestPage(params,sendData){
    return contractApi({
        url:'/material-request/page',
        method:'post',
        data:sendData,
        params:params
    })
}
//删除申领信息
export function deleteRequest(params){
    return contractApi({
        url:'/material-request',
        method:'delete',
        params:params
    })
}
//添加申领信息
export function addRequest(data){
    return contractApi({
        url:'/material-request',
        method:'post',
        data:data
    })
}
//修改申领信息
export function editRequest(data){
    return contractApi({
        url:'/material-request',
        method:'put',
        data:data
    })
}
//补全快递单号
export function addTrackingNumber(data){
    return contractApi({
        url:'/material-request/add-tracking-number',
        method:'put',
        data:data
    })
}
//干冰安排
export function arrangeDryIce(data){
    return contractApi({
        url:'/material-request/arrange-dry-ice',
        method:'put',
        data:data
    })
}
//取消安排或邮寄
export function notArrangeMail(data){
    return contractApi({
        url:'/material-request/not-arrange-mail',
        method:'put',
        data:data
    })
}
//导出
export function downloadRequest(data) {
    return contractApi({
        url: '/material-request/export',
        method: 'post',
        data:data,
        responseType: 'blob', // 设置响应类型为 blob
    });
}